module.exports = __webpack_public_path__ + "static/media/search.d4f3de81.svg";